import { FETCH_FLASHCARD } from '../constants/actionTypes';

const flashcard = (flashcard = [], action) => {
  switch (action.type) {
    case FETCH_FLASHCARD:
      return action.payload;
    default:
      return flashcard;
  }
};

export default flashcard;
